import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function PainSection() {
  return <section className="bg-parchment py-20 px-6 md:px-8" data-id="element-163">
      <div className="max-w-2xl mx-auto" data-id="element-164">
        <AnimatedSection data-id="element-165">
          <h2 className="text-3xl md:text-4xl font-serif text-bark mb-10 text-center" data-id="element-166">
            Lo que probablemente te pasa <br data-id="element-167" />
            <span className="text-bark/60 text-2xl md:text-3xl italic" data-id="element-168">
              (y casi nadie dice)
            </span>
          </h2>

          <div className="space-y-6 text-lg text-bark/90 leading-relaxed" data-id="element-169">
            <p data-id="element-170">Tenés buena intención.</p>
            <p data-id="element-171">Incluso amás a Dios.</p>
            <p data-id="element-172">Pero la vida te pasa por encima.</p>

            <p data-id="element-173">Un día estás bien. Dos días aguantás.</p>
            <p data-id="element-174">
              Al tercero… se te mezcló todo: trabajo, casa, mensajes, cansancio,
              discusiones, mil cosas.
            </p>

            <p data-id="element-175">Y la oración queda para “después”.</p>
            <p data-id="element-176">Después se convierte en una semana.</p>
            <p data-id="element-177">Después en “me da vergüenza volver”.</p>

            <p data-id="element-178">Y aparece ese pensamiento que no te deja tranquila:</p>

            <div className="my-8 pl-6 border-l-4 border-gold bg-linen/50 p-6 rounded-r-sm" data-id="element-179">
              <p className="font-serif font-bold text-xl text-wine italic" data-id="element-180">
                “Soy inconstante. Soy una mala católica.”
              </p>
            </div>

            <p data-id="element-181">No lo decís. Pero te lo sentís.</p>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}